import React, { useMemo, useState } from 'react';
import { Button, Menu, Dropdown } from 'antd';
import UserMenuDropdown from '@components/UserMenuDropdown';
import SearchBar from '@components/SearchBar';
import CampaignBreadcrumbs from '@components/CampaignBreadcrumbs';
import { ReactComponent as HelpSvg } from '@assets/icons/help.svg';
import { ReactComponent as UploadSvg } from '@assets/icons/upload.svg';
import { useDispatch } from 'react-redux';
import { toggleUploadAssetModal } from '@redux/actions/modalAction';
import { NotificationFeed } from '@components/NotificationFeed';
import { useCurrentWorkspace } from '@hooks/workspace';
import { useNavigate, useParams } from 'react-router-dom';
import { nonNull } from '@helpers/non-null';
import * as CookieConsent from 'vanilla-cookieconsent';

function AppHeader() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { campaignId, folderId } = useParams();
  const [showSearch, setShowSearch] = useState<boolean>(false);
  const [currentWorkspace] = useCurrentWorkspace(false);
  const workspaceId = currentWorkspace?.id;

  const menu = useMemo(() => {
    return (
      <Menu>
        <Menu.Item
          onClick={() => {
            window.open('https://help.streamwork.com/knowledge', '_blank');
          }}
        >
          Help center
        </Menu.Item>
        <Menu.Item
          onClick={() => {
            window.open('https://www.streamwork.com/contact', '_blank');
          }}
        >
          Contact support
        </Menu.Item>
        <Menu.Item
          onClick={() => {
            window.open('https://www.streamwork.com/contact', '_blank');
          }}
        >
          Submit product feedback
        </Menu.Item>

        {/* TODO: #86c63g6bw - hide Bootcamp(Onboarding page) */}
        {/* <Menu.Item
          onClick={() => {
            navigate(`/start/${workspaceId}`);
          }}
        >
          Onboarding
        </Menu.Item> */}
        <Menu.Item
          onClick={() => {
            CookieConsent.reset(true);
            window.location.reload();
          }}
        >
          Privacy settings
        </Menu.Item>
        <Menu.Divider />
        <Menu.Item
          onClick={() => {
            window.open('https://www.streamwork.com/blog', '_blank');
          }}
        >
          What&apos;s new?
        </Menu.Item>
      </Menu>
    );
  }, [workspaceId, navigate]);
  return (
    <div className="heade_container">
      <CampaignBreadcrumbs showSearch={showSearch} />
      <SearchBar showSearch={showSearch} setShowSearch={setShowSearch} />
      <Button
        type="primary"
        className="heade_container__btn"
        disabled={!currentWorkspace}
        onClick={() =>
          dispatch(
            toggleUploadAssetModal({
              visible: true,
              postAction: 'redirect-to-campaign',
              workspaceId: nonNull(currentWorkspace).id,
              campaignId,
              folderId
            })
          )
        }
      >
        <UploadSvg />
        Upload
      </Button>
      <NotificationFeed />
      <Dropdown
        overlay={menu}
        placement="bottomRight"
        overlayClassName="help_dropdown"
        trigger={['click']}
      >
        <Button
          className="heade_container__help"
          type="text"
          onClick={(e) => {
            if (document.activeElement instanceof HTMLElement) {
              document.activeElement.blur();
            }
          }}
        >
          <HelpSvg />
        </Button>
      </Dropdown>
      <UserMenuDropdown />
    </div>
  );
}

export default AppHeader;
